import axios from "axios";

let baseURL = "";
if(process.env.NODE_ENV === 'production'){
	baseURL = "https://www.tlsengenharia.com.br:53074/api";
}else{
  baseURL = "https://localhost:7027/api";  
}

export default axios.create({
  baseURL: baseURL
});

export const axiosPrivate_cookie = axios.create({
	baseURL: baseURL, // Substitua pela URL da sua API
	withCredentials: true, // Permite o envio de cookies com as requisições
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Access-Control-Allow-Headers': 'X-Requested-With',
		'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8' ,
		//'Accept': "application/json",
		//'Access-Control-Allow-Credentials':true
	}
});
